/* Flipper Kids — automatic NEW badge (site-wide collection grids)
   Added/updated by Claude (Anthropic AI) 2026-07-17, fixed 2026-07-23
   Shows a "NEW" badge, top-left of the card image, for any product created
   within NEW_BADGE_DAYS days of today — fully automatic, no manual list to
   maintain as new products are added.
   OVERRIDES lets specific handles use an explicit cutoff date instead of the
   day-count rule. CAMILA (42819) shows NEW until 2026-08-17.
   2026-07-23 fix: badge placement previously required an anchor to contain
   a genuine .hover-images wrap, dropped as a safety net on 2026-07-17 to
   stop duplicate badges (image-link + title-link both matching). That was
   too strict — some product-card variants (e.g. RENATA, handle
   מכנס-גינס-renata) don't render .hover-images at all, so those cards never
   got a badge though they qualified by date. Fix: dedupe per PRODUCT HANDLE
   (not per DOM wrapper) using a page-level placedHandles set, so any
   qualifying anchor for that handle can carry the badge exactly once,
   whether or not .hover-images exists — this keeps both cards from getting
   their own badge (the original bug) without silently skipping cards whose
   markup lacks .hover-images (the new bug). */
(function () {
  var NEW_BADGE_DAYS = 15;
  var OVERRIDES = {
    '42819': '2026-08-17' // מכנס ג'ינס גומי CAMILA
  };
  var cache = {};
  var placedHandles = {};

  function getHandle(href) {
    var m = href && href.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function isNewByDate(p) {
    if (!p || !p.created_at) return false;
    var ageDays = (Date.now() - new Date(p.created_at).getTime()) / 86400000;
    return ageDays >= 0 && ageDays <= NEW_BADGE_DAYS;
  }

  function isNewByOverride(handle) {
    return new Date() <= new Date(OVERRIDES[handle] + 'T23:59:59');
  }

  function findImageWrap(link) {
    // Prefer the real hover-image container when present.
    var wrap = link.querySelector('.hover-images') || link.closest('.hover-images');
    if (wrap) return wrap;
    // Fallback: an anchor that itself contains an <img> is almost certainly
    // the image link (not the title/text link) even without .hover-images —
    // use the anchor itself as the badge-positioning container.
    if (link.querySelector('img')) return link;
    return null;
  }

  function place(wrap) {
    if (wrap.dataset.fkNewBadge) return;
    wrap.dataset.fkNewBadge = '1';
    wrap.classList.add('fk-new-badge-wrap');
    var badge = document.createElement('span');
    badge.className = 'fk-new-badge';
    badge.textContent = 'NEW';
    wrap.appendChild(badge);
  }

  function scan() {
    var links = document.querySelectorAll('a.product-block__image, a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      (function (a) {
        var handle = getHandle(a.getAttribute('href') || '');
        if (!handle) return;
        if (a.closest('.product-gallery, .product__media, [data-product-single-media-group]')) return;
        if (placedHandles[handle]) return; // one badge per product, no matter how many anchors

        var wrap = findImageWrap(a);
        if (!wrap || wrap.dataset.fkNewBadge) return;

        if (Object.prototype.hasOwnProperty.call(OVERRIDES, handle)) {
          if (isNewByOverride(handle)) {
            placedHandles[handle] = true;
            place(wrap);
          }
          return;
        }
        fetchProduct(handle).then(function (p) {
          if (p && isNewByDate(p) && !placedHandles[handle]) {
            placedHandles[handle] = true;
            place(wrap);
          }
        });
      })(links[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }

  var t = null;
  var mo = new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(scan, 300);
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
